<gosuite-lightbox
	#lightboxInstance="lightbox"
	[showHeader]="showHeader"
	[showFooter]="showFooter"
	[showCloseButton]="showCloseButton"
	[showBackground]="showBackground"
	[backgroundColor]="backgroundColor"
	[boxColor]="boxColor"
	[showBoxShadow]="showBoxShadow"
	[closeByCloseButtonClick]="false"
	[closeByBackgroundClick]="false"
	[closeOnEscapeKey]="false"
	[boxWidth]="boxWidth"
	[boxHeight]="boxHeight"
	[isFancy]="isFancy"
	[closeButtonFixed]="closeButtonFixed"
	(onOpen)="handleLightboxOpen()"
	(onClose)="handleLightboxClose()"
	(onClickCloseButton)="handleClickCloseButton()"
	(onClickBackground)="handleClickBackground()"
	(onEscapeKeyPress)="handleEscapeKeyPress()"
>
	<section class="lightbox-body">
		<ng-container *ngIf="newsId === 'jt-booking-competition'">
			<div class="news">
				<a href="https://schmetterlingvor9.de/20191001-neo-jt-buwet" target="_blank">
					<img src="http://proxy.schmetterling-argus.de/cdn/neo/images/SMG_NEO_JT_Touristik_Plattform_Layer_650x500px_270919.jpg" alt="NEO JT Buchungswettbewerb">
				</a>
			</div>
		</ng-container>


		<ng-container *ngIf="newsId === '10-offers-validation'">
			<h1>Vakanzgeprüfte Angebote auf einen Klick</h1>

			<div class="news">
				<section class="news-image">
					<img src="/assets/images/news.jpg" alt="News"/>
				</section>
				<section class="news-text">
					Ab sofort können Sie in XENA 10 Angebote zu einem Hotel zeitgleich auf Vakanz prüfen.
					Wollen Sie weiterhin, wie bisher, nur ein Angebot zeitgleich prüfen, können Sie jederzeit über die Administration im Reiter Vakanzprüfung zur ursprünglichen Validierungsanzahl zurückkehren.
					Probieren Sie die neue Funktion gleich aus!
					<br>
					<br>
					Viele Grüße,
					<br>
					Ihr XENA-Team
					<br>
					<br>
					Tel.: +49 (0) 91 97/62 82-610
					<br>
					E-Mail: <a href="mailto:technology@schmetterling.de">technology@schmetterling.de</a>
				</section>
			</div>
		</ng-container>
	</section>

	<footer class="lightbox-footer">
		<div class="buttons">
			<gosuite-button type="submit" class="button-confirm" label="OK" (click)="close()"></gosuite-button>
		</div>
	</footer>
</gosuite-lightbox>



// WEBPACK FOOTER //
// ./src/app/shared/components/news-dialog/news-dialog.component.html